import React from 'react';
import { Outlet, useNavigate } from 'react-router';
import { signOut } from '../../service/common/firebase';
import { Button } from '@nextui-org/react';
import Navabr from '../components/common/Navbar';

export default function MainLayout() {

  return (
    <div className='flex flex-1 h-screen'>
      {/* NAV BAR */}
      <Navabr />
      <div className='flex flex-1 flex-col overflow-y-scroll'>
        {/* HEADER */}
        {/* PAGE CONTENT */}
        <div className='flex flex-1 '>
          <Outlet />
        </div>
      </div>
      {/* <div style={{display: 'flex', alignItems: 'center', margin: 24, gap: 16}}>
        <Button color='primary' onClick={gotoInterviewPage}>COLLOQUIO</Button>
        <Button color='primary' onClick={gotoFamiliesPage}>FAMIGLIE</Button>
        <Button color='primary' onClick={gotoCaregiversPage}>BADANTI</Button>
        <Button color='primary' onClick={gotoSettings}>IMPOSTAZIONI</Button>
        <Button onClick={signOut} style={{marginLeft: 'auto'}} color='primary'>LOGOUT</Button>
      </div> */}
    </div>
  )
}